/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WebAuthnAuthenticatorAttachment = {
    Any: 'any',
    Platform: 'platform',
    CrossPlatform: 'cross_platform'
} as const;
export type WebAuthnAuthenticatorAttachment = typeof WebAuthnAuthenticatorAttachment[keyof typeof WebAuthnAuthenticatorAttachment];


export function instanceOfWebAuthnAuthenticatorAttachment(value: any): boolean {
    for (const key in WebAuthnAuthenticatorAttachment) {
        if (Object.prototype.hasOwnProperty.call(WebAuthnAuthenticatorAttachment, key)) {
            if (WebAuthnAuthenticatorAttachment[key as keyof typeof WebAuthnAuthenticatorAttachment] === value) {
                return true;
            }
        }
    }
    return false;
}

export function WebAuthnAuthenticatorAttachmentFromJSON(json: any): WebAuthnAuthenticatorAttachment {
    return WebAuthnAuthenticatorAttachmentFromJSONTyped(json, false);
}

export function WebAuthnAuthenticatorAttachmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebAuthnAuthenticatorAttachment {
    return json as WebAuthnAuthenticatorAttachment;
}

export function WebAuthnAuthenticatorAttachmentToJSON(value?: WebAuthnAuthenticatorAttachment | null): any {
    return value as any;
}

export function WebAuthnAuthenticatorAttachmentToJSONTyped(value: any, ignoreDiscriminator: boolean): WebAuthnAuthenticatorAttachment {
    return value as WebAuthnAuthenticatorAttachment;
}

